"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Click here to expand the group members": "ここをクリックしてグループ メンバーを展開",
  "Click here to view the group members": "ここをクリックしてグループ メンバーを表示",
  "Company, {company}": ["組織/団体、", ["company"]],
  "Contact card, {name}": ["連絡先カード、", ["name"]],
  "Department, {department}": ["部門/部署、", ["department"]],
  "Email, {emailAddress}": ["メール アドレス、", ["emailAddress"]],
  "Expand members": "メンバーを展開",
  "Group - {members, plural, one {# member} other {# members}}": ["グループ - ", ["members", "plural", {
    one: ["#", " メンバー"],
    other: ["#", " メンバー"]
  }]],
  "Mobile phone, {mobilePhone}": ["携帯電話番号、", ["mobilePhone"]],
  "Mobile: {mobilePhone}": ["携帯: ", ["mobilePhone"]],
  "Name, {name}": ["名前、", ["name"]],
  "Title, {title}": ["役職、", ["title"]],
  "Type to search": "検索対象を入力します",
  "View members": "メンバーを表示",
  "Work phone, {workPhone}": ["勤務先電話番号、", ["workPhone"]],
  "Work: {workPhone}": ["勤務先: ", ["workPhone"]]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map